import { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../context/UserContext";

export function useVideoScreen() {
    const myState = useContext(UserContext);
    const [showVideo] = myState.showVideo;
    const [videoLoop] = useState([
        'https://be-vending-v3.akinons.id/media/logo/Honda%20CUV%20e%20%20%20Smart%20Ride%20Future%20Ready%20-%20Welovehonda%20Indonesia%20(1080p,%20h264).mp4',
    ]);
    const videoRef = useRef(null);
    const [videoIndex, setVidIndex] = useState(0);

    const handleNextVideo = () => {
        if (videoIndex === (videoLoop.length - 1)) {
            setVidIndex(0)
        } else {
            setVidIndex(videoIndex + 1)
        }
        if (videoRef.current) {
            videoRef.current.load(); // Load video baru dulu
            videoRef.current.play();
        }
    };

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    }, [videoIndex]);

    return {
        showVideo,
        videoLoop,
        videoRef,
        handleNextVideo,
        videoIndex
    };
}